import zanzibar from "../assets/zanzibar.jpg";
import senegal from "../assets/senegal.jpg";
import kenya from "../assets/kenya.jpg";
import namibia from "../assets/namibia.jpg";
import ivoryCoast from "../assets/ivory-coast.jpg";
import ghana from "../assets/ghana.jpg";
import morocco from "../assets/morocco.jpg";
import southAfrica from "../assets/south-africa.jpg";
import madagascar from "../assets/madagascar.jpg";
import tunisia from "../assets/tunisia.jpg";

const sliderData = [
  { id: 1, url: zanzibar, name: "Zanzibar" },
  { id: 2, url: senegal, name: "Senegal" },
  { id: 3, url: kenya, name: "Kenya" },
  { id: 4, url: namibia, name: "Namibia" },
  { id: 5, url: ivoryCoast, name: "Ivory Coast" },
  { id: 6, url: ghana, name: "Ghana" },
  { id: 7, url: morocco, name: "Morocco" },
  { id: 8, url: tunisia, name: "Tunisia" },
  { id: 9, url: southAfrica, name: "South Africa" },
  { id: 10, url: madagascar, name: "Madagascar" },
];

export default sliderData;
